/**
 * ntc-consigli.js — «Completa l'opera»: pezzi per la STESSA AUTO, prima quelli della stessa famiglia (11/09/2026).
 *
 * ⭐ Nessun elenco scritto a mano per prodotto: si chiede alla ricerca del negozio
 *    (tag veicolo) AND (tipo1 OR tipo2 …) — misurato: Giulietta + (Spoiler Posteriori OR Front Lip) = 16 = 10 + 6.
 *    Le schede arrivano già fatte dalla sezione ntc-consigli-dati (Section Rendering API).
 * ⚠️ L'auto: quella del pezzo; se il cliente ha scelto un'auto nella barra (localStorage «ntc_auto») e il pezzo le
 *    va, quella.
 * ⚠️ Si parte solo quando il riquadro sta per vedersi: a carrello chiuso non parte nessuna richiesta.
 * ⛔ Il pulsante è il modulo del tema (product-form): si aggiunge e si apre il carrello come ovunque, niente di nostro
 *    in mezzo al pagamento.
 */
(function () {
  'use strict';

  var SEZIONE = 'ntc-consigli-dati';
  var memoria = {};

  function scelta() {
    try {
      var s = window.localStorage.getItem('ntc_auto');
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }
  function basso(x) { return String(x || '').trim().toLowerCase(); }
  function tra(x) { return '"' + String(x).replace(/"/g, '') + '"'; }

  /* i tipi della stessa riga delle famiglie, dal più vicino al più lontano */
  function vicini(tipo, testo) {
    var t = basso(tipo);
    if (!t) { return []; }
    var righe = String(testo || '').split(/\r?\n/);
    for (var i = 0; i < righe.length; i++) {
      var voci = righe[i].split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var k = voci.map(basso).indexOf(t);
      if (k < 0) { continue; }
      return voci.map(function (x, j) { return { tipo: x, d: Math.abs(j - k), j: j }; })
        .filter(function (o) { return o.d > 0; })
        .sort(function (a, b) { return a.d - b.d || a.j - b.j; })
        .map(function (o) { return o.tipo; });
    }
    return [];
  }

  function ricerca(q) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
  }
  function chiedi(q) {
    var u = ricerca(q) + '&section_id=' + SEZIONE;
    if (!memoria[u]) {
      memoria[u] = fetch(u, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return memoria[u];
  }
  function schede(html) {
    var t = document.createElement('template');
    t.innerHTML = html || '';
    return Array.prototype.slice.call(t.content.querySelectorAll('.ntc-cons-card'));
  }
  function riempi(testo, v) {
    return String(testo || '').replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : ''; });
  }
  function elenco(tipi) {
    return tipi.length < 2 ? tipi.join('') : tipi.slice(0, -1).join(', ') + ' e ' + tipi[tipi.length - 1];
  }
  function scrivi(box, chi, testo) {
    var el = box.querySelector('[data-ntc="' + chi + '"]');
    if (!el) { return; }
    el.textContent = testo;
    el.hidden = !testo;
  }

  function avvia(box) {
    var pannello = box.querySelector('.ntc-cons');
    if (!pannello) { return; }
    var modo = box.getAttribute('data-modo') || 'pagina';
    var tipo = box.getAttribute('data-tipo') || '';
    var auto = (box.getAttribute('data-auto') || '').split('|').filter(Boolean);
    var nome = auto[0];
    var mia = scelta();
    /* ⛔ l'auto scelta nella barra vince solo se è UNA delle auto precise del pezzo: con la sola marca («Audi»)
       i consigli sarebbero per tutte le Audi */
    if (mia && mia.tag && auto.map(basso).indexOf(basso(mia.tag)) >= 0) {
      auto = [mia.tag];
      nome = mia.nome || mia.tag;
    }
    if (!auto.length) { return; }

    var visti = {};
    (box.getAttribute('data-escludi') || '').split('|').forEach(function (id) { if (id) { visti[id] = true; } });
    var famiglia = vicini(tipo, box.getAttribute('data-famiglie'));
    var nPrimi = parseInt(box.getAttribute('data-primi'), 10) || 4;
    var nAltri = parseInt(box.getAttribute('data-altri'), 10) || 0;
    var qAuto = '(' + auto.slice(0, 4).map(function (t) { return 'tag:' + tra(t); }).join(' OR ') + ')';

    Promise.all([
      famiglia.length ? chiedi(qAuto + ' AND (' + famiglia.slice(0, 10).map(function (t) { return 'product_type:' + tra(t); }).join(' OR ') + ')') : '',
      nAltri > 0 ? chiedi(qAuto) : ''
    ]).then(function (r) {
      /* primo piano: un pezzo per tipo, dal tipo più vicino; poi un secondo giro */
      var perTipo = {};
      schede(r[0]).forEach(function (c) {
        if (visti[c.getAttribute('data-id')]) { return; }
        var k = basso(c.getAttribute('data-tipo'));
        (perTipo[k] = perTipo[k] || []).push(c);
      });
      var primi = [], usati = [];
      for (var giro = 0; giro < nPrimi && primi.length < nPrimi; giro++) {
        for (var i = 0; i < famiglia.length && primi.length < nPrimi; i++) {
          var lista = perTipo[basso(famiglia[i])];
          var c = lista && lista[giro];
          if (!c || visti[c.getAttribute('data-id')]) { continue; }
          visti[c.getAttribute('data-id')] = true;
          primi.push(c);
          if (usati.indexOf(famiglia[i]) < 0) { usati.push(famiglia[i]); }
        }
      }
      /* il resto per la stessa auto, senza i tipi già in primo piano né quello del pezzo — al massimo 2 per tipo
         (⚠️ Giulietta: senza limite erano 6 maniglie interne su 8) */
      var fuori = famiglia.map(basso).concat([basso(tipo)]);
      var altri = [], contati = {};
      schede(r[1]).forEach(function (c) {
        var id = c.getAttribute('data-id');
        var k = basso(c.getAttribute('data-tipo'));
        if (altri.length >= nAltri || visti[id] || fuori.indexOf(k) >= 0 || (contati[k] || 0) >= 2) { return; }
        contati[k] = (contati[k] || 0) + 1;
        visti[id] = true;
        altri.push(c);
      });
      if (!primi.length && !altri.length) { return; }

      var v = { auto: nome, tipo: tipo, tipi: elenco(usati) };
      scrivi(box, 'occhiello', riempi(box.getAttribute('data-t-occhiello'), v));
      scrivi(box, 'titolo', riempi(box.getAttribute('data-t-titolo'), v));
      scrivi(box, 'sotto', usati.length ? riempi(box.getAttribute('data-t-sotto'), v) : '');

      var dove = box.querySelector('[data-ntc="primi"]');
      if (dove) {
        primi.forEach(function (c, n) {
          if (modo === 'cassetto') { c.classList.add('ntc-cons-card--mini'); }
          c.style.setProperty('--ntc-i', n);
          dove.appendChild(c);
        });
        dove.hidden = !primi.length;
      }
      var blocco = box.querySelector('[data-ntc="altri-blocco"]');
      if (blocco && altri.length) {
        var fila = blocco.querySelector('[data-ntc="altri"]');
        altri.forEach(function (c, n) {
          c.classList.add('ntc-cons-card--mini');
          c.style.setProperty('--ntc-i', n);
          fila.appendChild(c);
        });
        scrivi(box, 'altri-titolo', riempi(box.getAttribute('data-t-altri'), v));
        blocco.hidden = false;
      }
      var link = box.querySelector('[data-ntc="tutti"]');
      if (link) {
        link.href = ricerca(qAuto);
        scrivi(box, 'tutti', riempi(box.getAttribute('data-t-tutti'), v));
      }
      pannello.hidden = false;
      requestAnimationFrame(function () { pannello.classList.add('is-pronto'); });
    });
  }

  var vedi = 'IntersectionObserver' in window ? new IntersectionObserver(function (voci) {
    voci.forEach(function (x) {
      if (!x.isIntersecting) { return; }
      vedi.unobserve(x.target);
      avvia(x.target);
    });
  }, { rootMargin: '400px 0px' }) : null;

  function cerca() {
    document.querySelectorAll('[data-ntc-consigli]:not([data-ntc-visto])').forEach(function (box) {
      box.setAttribute('data-ntc-visto', '');
      if (vedi) { vedi.observe(box); } else { avvia(box); }
    });
  }

  /* il carrello laterale si ridisegna a ogni aggiunta: il riquadro nuovo si riempie di nuovo */
  var attesa = 0;
  new MutationObserver(function () {
    if (attesa) { return; }
    attesa = requestAnimationFrame(function () { attesa = 0; cerca(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  cerca();
})();
